import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[440px]">
      <div className="lg:w-1/2 relative overflow-hidden min-h-[300px] lg:min-h-[480px]">
        <img
          src="https://readdy.ai/api/search-image?query=Lifestyle%20flatlay%20composition%20of%20a%20laptop%20displaying%20colorful%20charts%20alongside%20fashion%20items%20sneakers%20sunglasses%20and%20a%20tote%20bag%20on%20a%20warm%20oak%20desk%20with%20a%20steaming%20coffee%20cup%20soft%20morning%20light%20streaming%20through%20sheer%20curtains%20cozy%20productive%20modern%20aesthetic%20editorial%20photography%20no%20text%20no%20logos&width=1000&height=700&seq=cta-section-v2-fresh-01&orientation=portrait"
          alt="Start using PandabuySpreadsheet"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/25 to-transparent"></div>
        <div className="absolute top-8 left-8">
          <span className="text-xs font-medium uppercase tracking-widest text-white bg-black/30 backdrop-blur-sm px-3 py-1.5 rounded-full">
            Get Started
          </span>
        </div>
        <div className="absolute bottom-8 left-8">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight">
            Join
            <br />
            The
            <br />
            Best Spreadsheet
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center">
        <div className="px-8 md:px-12 lg:px-16 py-12 md:py-16 text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            Start Using PandabuySpreadsheet Today
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-md mx-auto">
            Join thousands of smart shoppers who are already saving hundreds on fashion finds every month. Our pandabuy spreadsheet is free to browse, updated daily, and packed with the best verified deals across all fourteen categories.
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 mt-8 px-8 py-4 rounded-full bg-foreground-900 text-white font-semibold text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Access Main Store
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <p className="mt-4 text-xs text-foreground-400">
            No account required — browse the full pandabuy spreadsheet instantly
          </p>
        </div>
      </div>
    </section>
  );
}